import type { DeclaredDetails } from '@ballerine/common';

import { ProvidedDetailsContent as SharedProvidedDetailsContent } from '@/components/templates/shared';

type ProvidedDetailsProps = {
  providedDetails?: {
    websiteUrl?: string | null;
    companyName?: string | null;
    merchantId?: string | null;
    countryCode?: string | null;
    declaredDetails?: DeclaredDetails;
  } | null;
};

export const ProvidedDetailsContent: React.FC<ProvidedDetailsProps> = ({ providedDetails }) => {
  return <SharedProvidedDetailsContent providedDetails={providedDetails} />;
};
